if (!customElements.get('sticky-header')) {
  customElements.define(
    'sticky-header',
    class StickyHeader extends HTMLElement {
      constructor() {
        super();

        this.header = null;
        this.headerBounds = { top: 0, bottom: 0 };
        this.currentScrollTop = 0;
        this.latestScrollTop = 0;
        this.preventReveal = false;
        this.isScrolling = null;
        this.scrollRaf = null;
        this.resizeObserver = null;
      }

      connectedCallback() {
        this.header = document.getElementById('shopify-section-header');

        if (!this.header) {
          return;
        }

        this.predictiveSearch = this.querySelector('predictive-search');
        this.currentScrollTop = this.getScrollTop();
        this.latestScrollTop = this.currentScrollTop;

        this.onScrollHandler = this.onScroll.bind(this);
        this.updateHeaderBoundsHandler = this.updateHeaderBounds.bind(this);
        this.hideHeaderOnScrollUp = () => {
          this.preventReveal = true;
        };

        this.updateHeaderBounds();

        this.addEventListener(
          'preventHeaderReveal',
          this.hideHeaderOnScrollUp
        );

        window.addEventListener('scroll', this.onScrollHandler, {
          passive: true
        });

        window.addEventListener('resize', this.updateHeaderBoundsHandler, {
          passive: true
        });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(
            this.updateHeaderBoundsHandler
          );
          this.resizeObserver.observe(this.header);
        }
      }

      disconnectedCallback() {
        this.removeEventListener(
          'preventHeaderReveal',
          this.hideHeaderOnScrollUp
        );

        window.removeEventListener('scroll', this.onScrollHandler);
        window.removeEventListener('resize', this.updateHeaderBoundsHandler);

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }

        if (this.scrollRaf !== null) {
          cancelAnimationFrame(this.scrollRaf);
        }

        if (this.isScrolling) {
          window.clearTimeout(this.isScrolling);
        }
      }

      getScrollTop() {
        return window.pageYOffset || document.documentElement.scrollTop || 0;
      }

      getDocumentTop(element) {
        let top = 0;
        let node = element;

        while (node) {
          top += node.offsetTop || 0;
          node = node.offsetParent;
        }

        return top;
      }

      updateHeaderBounds() {
        if (!this.header) {
          return;
        }

        const top = this.getDocumentTop(this.header);

        this.headerBounds = {
          top,
          bottom: top + this.header.offsetHeight
        };
      }

      onScroll() {
        this.latestScrollTop = this.getScrollTop();

        if (this.predictiveSearch && this.predictiveSearch.isOpen) {
          this.currentScrollTop = this.latestScrollTop;
          return;
        }

        if (this.scrollRaf !== null) {
          return;
        }

        this.scrollRaf = requestAnimationFrame(() => {
          this.scrollRaf = null;
          this.updateHeaderState(this.latestScrollTop);
        });
      }

      updateHeaderState(scrollTop) {
        const scrollingDown = scrollTop > this.currentScrollTop;
        const scrollingUp = scrollTop < this.currentScrollTop;
        const pastHeader = scrollTop > this.headerBounds.bottom;

        if (scrollingDown && pastHeader) {
          this.hide();
        } else if (scrollingUp && pastHeader) {
          if (!this.preventReveal) {
            this.reveal();
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = window.setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            this.hide();
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.reset();
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        const wasHidden = this.header.classList.contains(
          'shopify-section-header-hidden'
        );

        this.header.classList.add(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky'
        );

        if (!wasHidden) {
          this.closeHeaderDropdowns();
        }
      }

      reveal() {
        this.header.classList.add(
          'shopify-section-header-sticky',
          'animate'
        );
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        this.header.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate'
        );
      }
      closeHeaderDropdowns() {
        const headerDropdowns = this.header.querySelectorAll('.dropdown');

        headerDropdowns.forEach((dropdown) => {
          const dropdownItems = dropdown.querySelector('.dropdown-list-wrap');

          dropdown.setAttribute('aria-expanded', 'false');

          if (dropdownItems) {
            dropdownItems.setAttribute('aria-hidden', 'true');
          }
        });
      }
    }
  );
}
